<template>
  <div class="d-flex justify-center align-center" style="height: calc(100vh - 120px)">
    <div>
      <h2 class="text-center">{{ $t('verify.title') }}</h2>
      <div class="text-center">
        <i class="info">{{ $t('verify.info') }}</i>
      </div>
      <div class="mt-5 justify-center d-flex">
        <kicklet-button :text="$t('verify.button')" prepend-icon="mdi-check-decagram" color="primary" @click="dialog = true"/>
      </div>
      <verify-dialog v-model="dialog"/>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import VerifyDialog from '@/components/dialog/VerifyDialog';
import KickletButton from '@/components/custom/kicklet/KickletButton.vue';

const dialog = ref(false);
</script>

<style scoped>

</style>
